import { Board } from "../board/Board";
import { ChallengeHUD } from "./hud/ChallengeHUD";
import { ChallengeGUI } from "./gui/ChallengeGUI";
import { PauseLayer } from "../board/PauseLayer";
import { PawnPromotionLayer } from "../board/PawnPromotionLayer";
import { GameConstants } from "../GameConstants";
import { GameVars } from "../GameVars";
import { ChallengeManager } from "./ChallengeManager";
import { ChallengeEndLayer } from "./ChallengeEndLayer";

export class ChallengeState extends Phaser.State {

    public static currentInstance: ChallengeState = null;

    public board: Board;
    public hud: ChallengeHUD;
    public gui: ChallengeGUI;
    public pauseLayer: PauseLayer;

    private pawnPromotionLayer: PawnPromotionLayer;

    public init(): void {

        ChallengeState.currentInstance = this;

        this.pauseLayer = null;
    }

    public create(): void {

        const backgroundImage = this.add.image(GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2, "texture_atlas_1", "bg.png");
        backgroundImage.scale.set(2, 2 * GameVars.scaleY);
        backgroundImage.anchor.set(.5);

        ChallengeManager.init(this.game);
        
        this.game.camera.flash(0x000000, GameConstants.TIME_FADE, false);
    }

    public setBoard(): void {

        this.board = new Board(this.game);
        this.add.existing(this.board);

        this.hud = new ChallengeHUD(this.game);
        this.add.existing(this.hud);

        this.gui = new ChallengeGUI(this.game);
        this.add.existing(this.gui);

        ChallengeManager.startGame();
    }

    public check(uploadedGame?: boolean): void {
        
        this.board.check(uploadedGame);
    }

    public uncheck(): void {
        
        this.board.uncheck();
    }

    public showPawnPromotionMenu(): void {

        // mostrar el menu
        this.pawnPromotionLayer = new PawnPromotionLayer(this.game);
        this.add.existing(this.pawnPromotionLayer);
    }

    public removePawnPromotionLayer(): void {

        this.pawnPromotionLayer.destroy();
    }

    public gameOver(): void {

        if (GameConstants.SPONSOR === GameConstants.SPONSOR_POKI) {
            PokiSDK.gameplayStop();
        }

        const checkMateLayer = new ChallengeEndLayer(this.game, false);
        this.add.existing(checkMateLayer);
    }

    public checkmate(): void {

        if (GameConstants.SPONSOR === GameConstants.SPONSOR_POKI) {
            PokiSDK.gameplayStop();
        }

        const checkMateLayer = new ChallengeEndLayer(this.game, true);
        this.add.existing(checkMateLayer);
    }
}
